<p-dialog [(visible)]="display" [style]="{ width: '60vw' }" [blockScroll]="true" [modal]="true" [closable]="false">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 100%">
            <h5 class="p-mb-0">{{ checkDialogType == 'EDIT'? 'Edit': '' }} Write Check </h5>
            <div class="p-field-checkbox p-mb-0" style="margin-right: 6rem">
                <label for="binary" class="p-mr-3">Print</label>
                <p-checkbox [(ngModel)]="isPrint" [binary]="true" inputId="binary"></p-checkbox>
            </div>
            <div *ngIf="statementMessage">
                <strong [ngClass]="'status-open'">{{statementMessage}}</strong>
            </div>
            <span title="Edit Write Check" class="btnBars" (click)="viewToEdit(checkId)" *ngIf="checkId > 0 && checkDialogType == 'VIEW' && !isVoided && isEditableViewDialog">
                <i class="pi pi-pencil"></i>
            </span>
        </div>
        <button pButton pRipple type="button" icon="pi pi-times" (click)="onClose('cancel')" class="p-button-rounded p-dialog-header-icon p-dialog-header-close"></button>
    </ng-template>
    <form [formGroup]="writeCheckForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-8 p-d-flex">
                    <label class="p-mr-2">Bank Account</label>
                    <div style="flex-grow: 1">
                        <!-- <p-dropdown placeholder="Select a Bank" optionLabel="name" [showClear]="true" appendTo="body" 
                            [options]="banks" optionValue="id" formControlName="bankFinancialAccountId" (onChange)="onChangeBankAccount($event)">
                        </p-dropdown> -->

                        <liono-treeSelect class="border-bottom-input" [options]="banks" appendTo="body" placeholder="Select a Bank" formControlName="bankFinancialAccountId" 
                        display="comma" [metaKeySelection]="false" selectionMode="single" (onNodeSelect)="onChangeBankAccount($event)"></liono-treeSelect>
                    

                        <div *ngIf="isTouched('bankFinancialAccountId')">
                            <div class="p-mt-1" *ngIf="hasRequiredError('bankFinancialAccountId')">
                                <small class="p-invalid">
                                    Bank account is required.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-col-4 p-d-flex" style="flex-direction: row-reverse">
                    <h6 style="color: red" class="p-mt-2">{{ endingBalance | customNumberFormat: fractionDigits | currencySymbol }}</h6>
                    <label class="p-mr-2">Ending Balance</label>
                </div>
            </div>
            <div class="p-grid" *ngIf="isAllowPostingPeriod">
                <div class="p-col-8 p-d-flex"></div>
                <div class="p-col-2 p-text-right">
                   <label>Posting Period:<span style="color: red">*</span></label>
                </div>
                <div class="p-col-2">
                    <app-posting-period-selector [transactionDate]="writeCheckForm?.get('checkDate')?.value"
                        [selectedPostingPeriod]="currentPostingPeriodInfo" [moduleName]="'Check'"
                        [isViewMode]="checkDialogType === 'VIEW'" (postingInfoChange)="onPostingInfoChange($event)">
                    </app-posting-period-selector>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-8 p-d-flex"></div>
                <div class="p-col-2 p-text-right">
                    <label>Ref No.</label>
                </div>
                <div class="p-col-2">
                    <input type="text" class="small" pInputText style="width: 100% !important" formControlName="referenceNo" />
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-8"></div>
                <div class="p-col-2 p-text-right">
                    <label>Date</label>
                </div>
                <div class="p-col-2">
                    <p-calendar [showIcon]="true" inputId="icon" appendTo="body" formControlName="checkDate"></p-calendar>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-8 p-d-flex">
                    <label class="p-mr-2">Pay to the Order of</label>
                    <input type="text" class="small" pInputText style="flex-grow: 1" [(ngModel)]="payToName" [ngModelOptions]="{ standalone: true }" disabled />
                    <span class="btnBars p-mr-0" (click)="addPayTo()" *ngIf="checkDialogType != 'VIEW'">
                        <i class="pi pi-plus" *ngIf="payToName == null || payToName == '' || payToName == undefined"></i>
                        <i class="pi pi-pencil" *ngIf="payToName !== null && payToName !== '' && payToName !== undefined && !creditMemo?.id"></i>
                    </span>
                </div>
                <div class="p-col-2 p-text-right">
                    <label>{{ currencySymbol }}</label>
                </div>
                <div class="p-col-2">
                    <p-inputNumber inputId="locale-user" [minFractionDigits]="fractionDigits" formControlName="amount" (focusout)="convertNumToWords()"></p-inputNumber>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12 p-d-flex">
                    <input type="text" class="small" pInputText style="flex-grow: 1" formControlName="amountInWords" />
                    <label class="p-ml-2">Dollars</label>
                </div>
            </div>
            <div class="p-grid" *ngIf="payTo == 'vendor'">
                <div class="p-col-12">
                    <label
                        >Address
                        <span *ngIf="activeVendorAddresses?.length > 1" (click)="onChangeVendor(vendorDetails, 'show_list')" class="p-ml-4 btnBars">
                            <i class="pi pi-pencil" *ngIf="checkDialogType != 'VIEW'"></i>
                        </span>
                    </label>
                    <p class="p-mb-0">
                        {{ selectedVendorDD?.name }}
                    </p>
                    <p class="p-mb-0"> {{ ordersVendorAddr }}<span *ngIf="ordersVendorAddr !== ''">,</span> </p>
                    <p class="p-mb-0"> {{ ordersVendorCity }}<span *ngIf="ordersVendorCity !== ''">, </span> {{ ordersVendorState }} <span *ngIf="ordersVendorState !== ''">, </span> {{ ordersVendorCountry }} <span *ngIf="ordersVendorCountry !== ''">, </span> {{ ordersVendorZipcode }} </p>
                    <p class="p-mb-0"
                        >{{ ordersVendorContact }}
                        <span *ngIf="vendorDetails?.vendorContacts?.length > 1" (click)="changeVendorContact()" class="p-ml-4 pointer">
                            <i class="pi pi-pencil" *ngIf="checkDialogType != 'VIEW'"></i>
                        </span>
                    </p>
                    <p class="p-mb-0">{{ ordersVendorPhone }}</p>
                </div>
            </div>
            <div class="p-grid" *ngIf="payTo == 'customer'">
                <div class="p-col-12">
                    <label
                        >Address
                        <span *ngIf="accountInfo && accountInfo.accountAddresses && accountInfo.accountAddresses.length > 0" class="p-ml-4 btnBars" (click)="editAccountAddress()">
                            <i class="pi pi-pencil" *ngIf="checkDialogType != 'VIEW'"></i>
                        </span>
                    </label>
                    <p class="p-mb-0"> {{ accountInfo?.businessName }} </p>
                    <ng-container *ngIf="accountInfo">
                        <!-- Street -->
                        <p class="p-mb-0"> {{ accountAddressInfo?.address?.streetAddress1 }} <span *ngIf="accountAddressInfo?.address && accountAddressInfo?.address?.streetAddress1 && accountAddressInfo?.address?.streetAddress1 != '' && accountAddressInfo?.address?.streetAddress2 && accountAddressInfo?.address?.streetAddress2 != ''">,</span> {{ accountAddressInfo?.address?.streetAddress2 }} </p>
                        <!--Address-->
                        <p class="p-mb-0">
                            {{ accountAddressInfo?.address?.city?.name }} <span *ngIf="accountAddressInfo?.address && accountAddressInfo?.address?.city && accountAddressInfo?.address?.city?.name && accountAddressInfo?.address?.city?.name != '' && accountAddressInfo?.address?.city?.state && accountAddressInfo?.address?.city?.state?.name != ''">,</span> {{ accountAddressInfo?.address?.city?.state?.name }} <span *ngIf="accountAddressInfo?.address && accountAddressInfo?.address?.city && accountAddressInfo?.address?.city?.state && accountAddressInfo?.address?.city?.state?.name && accountAddressInfo?.address?.city?.state?.name != '' && accountAddressInfo?.address?.city?.state?.country && accountAddressInfo?.address?.city?.state?.country?.name != ''">,</span> {{ accountAddressInfo?.address?.city?.state?.country?.name }}
                            <span *ngIf="accountAddressInfo?.address && accountAddressInfo?.address?.city && accountAddressInfo?.address?.city?.state && accountAddressInfo?.address?.city?.state?.country && accountAddressInfo?.address?.city?.state?.country?.name && accountAddressInfo?.address?.city?.state?.country?.name != '' && accountAddressInfo?.address?.zipCode && accountAddressInfo?.address?.zipCode != ''">,</span> {{ accountAddressInfo?.address?.zipCode }}
                        </p>
                        <!--billing contact-->
                        <p class="p-mb-0 p-d-flex">
                            {{ billingAddressContact?.firstName }} {{ billingAddressContact?.lastName ? " " : "" }} {{ billingAddressContact?.lastName }}
                            <span class="p-ml-4 btnBars" (click)="openContactSelectionModal('BILLING')" *ngIf="this.accountInfo?.accountContacts.length > 1">
                                <i class="pi pi-pencil" *ngIf="checkDialogType != 'VIEW'"></i>
                            </span>
                        </p>
                        <p class="p-mb-0"> {{ billingAddressContact && billingAddressContact?.contactPhones && billingAddressContact?.contactPhones[0]?.phone && billingAddressContact?.contactPhones[0]?.phone?.number ? billingAddressContact?.contactPhones[0]?.phone?.number : "" }} </p>
                    </ng-container>
                </div>
            </div>
            <div class="p-grid" *ngIf="payTo == 'employee'">
                <div class="p-col-12">
                    <label >Address </label>
                    <p class="p-mb-0">
                        {{ selectedEmployee?.name }}
                    </p>
                    <p class="p-mb-0"> {{ selectedEmployee?.location?.address?.city?.name }}<span *ngIf="selectedEmployee && selectedEmployee?.location?.address?.city?.name !== ''">, </span>
                        {{ selectedEmployee?.location?.address?.state?.name }} <span *ngIf="selectedEmployee &&selectedEmployee?.location?.address?.state?.name !== ''">,
                        </span> {{ selectedEmployee?.location?.address?.country?.name }} <span *ngIf="selectedEmployee && selectedEmployee?.location?.address?.country?.name !== ''">, 
                        </span> {{ selectedEmployee?.location?.address?.zipCode }} </p>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Memo</label>
                    <input type="text" pInputText formControlName="memo" />
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <p-tabView class="custom-header" [(activeIndex)]="index">
                        <p-tabPanel *ngIf="!creditMemo && !creditMemo?.id">
                            <ng-template pTemplate="header">
                                <div class="p-d-flex p-jc-between" style="width: 100%">
                                    <span>Expenses</span>
                                    <span>{{ amountExpense | customNumberFormat: fractionDigits | currencySymbol }}</span>
                                </div>
                            </ng-template>
                            <p-table [value]="expenses" responsiveLayout="scroll">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Financial Account</th>
                                        <th>Amount</th>
                                        <th>Memo</th>
                                        <th style="width: 120px">Action</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-account let-index="rowIndex">
                                    <tr>
                                        <td>{{ checkDialogType == "VIEW" ? account?.bankFinancialAccount : account.financialAccountId?.label }}</td>
                                        <!-- <td>{{ account?.bankFinancialAccount }}</td> -->
                                        <td>{{ account.amount | customNumberFormat: fractionDigits | currencySymbol }}</td>
                                        <td>{{ account.memo }}</td>
                                        <td class="action">
                                            <span class="btnBars" (click)="editExpense(account)" *ngIf="checkDialogType != 'VIEW'">
                                                <i class="pi pi-pencil" ></i>
                                            </span>
                                            <div class="btnBars p-mr-0" (click)="removeItem(index, 'expense')" *ngIf="checkDialogType != 'VIEW'">
                                                <i class="pi pi-trash" ></i>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabPanel>
                        <p-tabPanel *ngIf="!creditMemo && !creditMemo?.id">
                            <ng-template pTemplate="header">
                                <div class="p-d-flex p-jc-between" style="width: 100%">
                                    <span>Items</span>
                                    <span>{{ amountItem | customNumberFormat: fractionDigits | currencySymbol }}</span>
                                </div>
                            </ng-template>
                            <p-table [value]="items" responsiveLayout="scroll">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Item No.</th>
                                        <th>Description</th>
                                        <th>Qty</th>
                                        <th>Cost</th>
                                        <th>Amount</th>
                                        <th style="width: 120px">Action</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-product let-index="rowIndex">
                                    <tr>
                                        <td>{{ product.itemNo }}</td>
                                        <td>{{ product.description | shorten: 55 }}</td>
                                        <td pEditableColumn class="action">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-inputNumber [min]="1" [minFractionDigits]="qtyFractionDigits" [maxFractionDigits]="qtyFractionDigits" mode="decimal" (keypress)="utilService.isNumberKey($event)" [ngModelOptions]="{ standalone: true }" 
                                                        [(ngModel)]="product.ordQty" (focusout)="calculateSubTotal(product, product.ordQty, product.costPrice)" [disabled]="checkDialogType == 'VIEW'">
                                                    </p-inputNumber>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ product.ordQty | customNumberFormat: qtyFractionDigits}}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td pEditableColumn class="action">
                                            <p-cellEditor *ngIf="product.typeId != 4">
                                                <ng-template pTemplate="input">
                                                    <p-inputNumber [min]="1" [ngModelOptions]="{ standalone: true }" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" [(ngModel)]="product.costPrice" 
                                                        (focusout)="calculateSubTotal(product, product.ordQty, product.costPrice)" [disabled]="checkDialogType == 'VIEW'">
                                                    </p-inputNumber>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ product.costPrice | customNumberFormat: fractionDigits | currencySymbol }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td>{{ product.cost | customNumberFormat: fractionDigits | currencySymbol }}</td>
                                        <td class="action">
                                            <div class="btnBars p-mr-0" (click)="removeItem(index, 'item')" *ngIf="checkDialogType != 'VIEW'">
                                                <i class="pi pi-trash" ></i>
                                            </div>
                                        </td>
                                    </tr>
                                    <!-- bundle items -->
                                    <tr *ngFor="let bundle of product.bundleDetails" class="bundleRow">
                                        <td>
                                            {{ bundle.itemNo }}
                                        </td>
                                        <td>
                                            {{ bundle.description | shorten: 55 }}
                                        </td>
                                        <td pEditableColumn class="action">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-inputNumber [min]="1" [minFractionDigits]="qtyFractionDigits" [maxFractionDigits]="qtyFractionDigits" mode="decimal" (keypress)="utilService.isNumberKey($event)" [ngModelOptions]="{ standalone: true }" 
                                                        [(ngModel)]="bundle.ordQty" (focusout)="calculateSubTotal(product, bundle.ordQty, bundle.costPrice, bundle)" [disabled]="checkDialogType == 'VIEW'">
                                                    </p-inputNumber>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ bundle.ordQty | customNumberFormat: qtyFractionDigits}}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td pEditableColumn class="action">
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-inputNumber [min]="1" [ngModelOptions]="{ standalone: true }" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" [(ngModel)]="bundle.costPrice" (focusout)="calculateSubTotal(product, bundle.ordQty, bundle.costPrice, bundle)" [disabled]="checkDialogType == 'VIEW'"></p-inputNumber>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ bundle.costPrice | customNumberFormat: fractionDigits | currencySymbol }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td>
                                            {{ bundle.cost | customNumberFormat: fractionDigits | currencySymbol }}
                                        </td>
                                        <td class="action"></td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="footer">
                                    <tr>
                                        <td colspan="4" class="p-text-right">SubTotal</td>
                                        <td colspan="4">{{ subTotal | customNumberFormat: fractionDigits | currencySymbol }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="4" class="p-text-right">Freight</td>
                                        <td colspan="4">
                                            <div class="p-inputgroup">
                                                <span>{{ baseCurrency?.symbol }}</span>
                                                <!-- <input pInputText type="text" formControlName="freight" (input)="findsum()" class="footer-input" [ngModelOptions]="{ standalone: true }" (keypress)="utilService.isNumberKey($event)" /> -->
                                                <p-inputNumber formControlName="freight" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" (focusout)="findsum()" class="footer-input"></p-inputNumber>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="4" class="action">
                                            <div class="p-d-flex" style="flex-direction: row-reverse">
                                                <div class="p-d-flex">
                                                    <p-inputNumber formControlName="discountAmount" (focusout)="findsum()" mode="decimal" [min]="0" [minFractionDigits]="fractionDigits" [max]="selectedValueOption?.description == '%' ? 99.99 : subTotal" class="footer-input" [ngModelOptions]="{ standalone: true }"></p-inputNumber>
                                                    <p-dropdown [options]="valueOptions" (onChange)="findsum()" class="footer-dd" optionLabel="description" appendTo="body" formControlName="discountType" [ngModelOptions]="{ standalone: true }"></p-dropdown>
                                                </div>
                                                <span class="p-mr-3 p-pt-1"> Discount </span>
                                            </div>
                                        </td>
                                        <td colspan="4">{{ discount | customNumberFormat: fractionDigits | currencySymbol }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="4" class="p-text-right">Total</td>
                                        <td colspan="4">{{ amountItem | customNumberFormat: fractionDigits | currencySymbol }}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabPanel>
                        <p-tabPanel *ngIf="payTo == 'customer' && payToName !== null && payToName !== '' && payToName !== undefined">
                            <ng-template pTemplate="header">
                                <div class="p-d-flex p-jc-between" style="width: 100%">
                                    <span>Credit Memo</span>
                                    <span>{{ totalCredit | customNumberFormat: fractionDigits | currencySymbol }}</span>
                                </div>
                            </ng-template>
                            <!-- <p-table [value]="availableCredits" [(selection)]="selectedCredits" dataKey="id" selectionMode="multiple" (onRowSelect)="calculateTotalCreditAmount()" (onRowUnselect)="calculateTotalCreditAmount()">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Memo No.</th>
                                        <th>Status</th>
                                        <th>Created Date</th>
                                        <th>Created By</th>
                                        <th>Amount</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-creditMemo let-index="rowIndex">
                                    <tr [pSelectableRow]="creditMemo" [pSelectableRowIndex]="rowIndex">
                                        <td>{{ creditMemo?.number }}</td>
                                        <td>{{ creditMemo?.creditMemoStatus }}</td>
                                        <td>{{ creditMemo?.createdDate | date: "MM/dd/yyyy"}}</td>
                                        <td>{{ creditMemo?.createdByUser }}</td>
                                        <td>{{ creditMemo?.amount | customNumberFormat: fractionDigits | currencySymbol}}</td>
                                    </tr>
                                </ng-template>
                            </p-table> -->


                            <p-table [value]="availableCredits" [(selection)]="selectedCredits" dataKey="creditMemoId" selectionMode="multiple" (onHeaderCheckboxToggle)="calculateTotalCreditAmount()" (onRowSelect)="calculateTotalCreditAmount()" (onRowUnselect)="calculateTotalCreditAmount()">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Memo No.</th>
                                        <th>Status</th>
                                        <th>Created Date</th>
                                        <th>Created By</th>
                                        <th>Amount</th>
                                        <th>Paid Amount</th>
                                        <th style="width: 4rem">
                                            <p-tableHeaderCheckbox [disabled]="checkDialogType == 'VIEW'"></p-tableHeaderCheckbox>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-creditM let-index="rowIndex">
                                    <tr>
                                        <!-- <td>
                                            <span class="p-mb-0 acc-name-popup-link" (click)="navigateToCreditMemo(creditM)">
                                                {{ creditM?.number }}
                                            </span>
                                        </td> -->
                                        <td>
                                            <span class="p-mb-0 acc-name-popup-link" (click)="showCreditMemoDialog(creditM)">
                                                {{ creditM?.number }}
                                            </span>
                                        </td>
                                        <td>{{ creditM?.creditMemoStatus }}</td>
                                        <td>{{ creditM?.createdDate | date: "MM/dd/yyyy"}}</td>
                                        <td>{{ creditM?.createdByUser }}</td>
                                        <td>{{ creditM?.amount | customNumberFormat: fractionDigits | currencySymbol}}</td>
                                        <td pEditableColumn>
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-inputNumber mode="decimal" [min]="1" [max]="creditM?.amount" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" 
                                                        [(ngModel)]="creditM.paidCredit" [ngModelOptions]="{ standalone: true }" 
                                                        (keypress)="utilService.isNumberKey($event)" (focusout)="calculateTotalCreditAmount()" (keydown.enter)="calculateTotalCreditAmount()"
                                                        [disabled]="checkDialogType == 'VIEW'">
                                                    </p-inputNumber>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ creditM.paidCredit | customNumberFormat: fractionDigits | currencySymbol }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td>
                                            <p-tableCheckbox [value]="creditM" [disabled]="checkDialogType == 'VIEW'"></p-tableCheckbox>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabPanel>
                        <!-- <p-tabPanel *ngIf="payTo == 'vendor' && payToName !== null && payToName !== '' && payToName !== undefined">
                            <ng-template pTemplate="header">
                                <div class="p-d-flex p-jc-between" style="width: 100%">
                                    <span>Vendor Credit</span>
                                    <span>{{ totalVendorCredit | customNumberFormat: fractionDigits | currencySymbol }}</span>
                                </div>
                            </ng-template>
                            <p-table 
                                [value]="availableVendorCredits" 
                                [(selection)]="selectedVendorCredits" 
                                dataKey="id" 
                                selectionMode="multiple" 
                                (onHeaderCheckboxToggle)="calculateTotalVendorCreditAmount()" 
                                (onRowSelect)="calculateTotalVendorCreditAmount()" 
                                (onRowUnselect)="calculateTotalVendorCreditAmount()">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Memo No.</th>
                                        <th>Status</th>
                                        <th>Created Date</th>
                                        <th>Created By</th>
                                        <th>Amount</th>
                                        <th>Paid Amount</th>
                                        <th style="width: 4rem">
                                            <p-tableHeaderCheckbox [disabled]="checkDialogType == 'VIEW'"></p-tableHeaderCheckbox>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-vendorCredit let-index="rowIndex">
                                    <tr>
                                        <td>
                                            <span class="p-mb-0 acc-name-popup-link" (click)="showVendorCreditDialog(vendorCredit)">
                                                {{ vendorCredit?.number }}
                                            </span>
                                        </td>
                                        <td>{{ vendorCredit?.creditMemoStatus }}</td>
                                        <td>{{ vendorCredit?.creditMemoDate | date: "MM/dd/yyyy"}}</td>
                                        <td>{{ vendorCredit?.createdByUser }}</td>
                                        <td>{{ vendorCredit?.totalCreditAmount | customNumberFormat: fractionDigits | currencySymbol}}</td>
                                        <td pEditableColumn>
                                            <p-cellEditor>
                                                <ng-template pTemplate="input">
                                                    <p-inputNumber mode="decimal" [min]="1" [max]="vendorCredit?.pendingCreditAmount" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" 
                                                        [(ngModel)]="vendorCredit.appliedAmount" [ngModelOptions]="{ standalone: true }" 
                                                        (keypress)="utilService.isNumberKey($event)" (onInput)="calculateTotalVendorCreditAmount()" (focusout)="calculateTotalVendorCreditAmount()" (keydown.enter)="calculateTotalVendorCreditAmount()"
                                                        [disabled]="checkDialogType == 'VIEW'">
                                                    </p-inputNumber>
                                                </ng-template>
                                                <ng-template pTemplate="output">
                                                    {{ vendorCredit.appliedAmount | customNumberFormat: fractionDigits | currencySymbol }}
                                                </ng-template>
                                            </p-cellEditor>
                                        </td>
                                        <td>
                                            <p-tableCheckbox [value]="vendorCredit" [disabled]="checkDialogType == 'VIEW'"></p-tableCheckbox>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-tabPanel> -->
                        <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
                            <ng-template pTemplate="header">
                                <span class="btnBars p-mr-0" (click)="addExpense()" *ngIf="index == 0 && !creditM && !creditM?.id">
                                    <i class="pi pi-plus" *ngIf="checkDialogType != 'VIEW'"></i>
                                </span>
                                <span class="btnBars p-mr-0" (click)="openProducts()" *ngIf="index == 1 && !creditM && !creditM?.id && payToName !== null && payToName !== '' && payToName !== undefined">
                                    <i class="pi pi-plus" *ngIf="checkDialogType != 'VIEW'"></i>
                                </span>
                            </ng-template>
                        </p-tabPanel>
                    </p-tabView>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button *ngIf="checkDialogType == 'VIEW' && isShowVoidDelete" type="button" pButton label="Void" [disabled]="isVoided" (click)="voidOrDelete(true)" class="p-mr-2"></button>
        <p-button *ngIf="checkDialogType == 'VIEW' && isShowVoidDelete" [label]="'Delete'" (click)="voidOrDelete(false)" styleClass="p-button-danger" class="p-mr-2"></p-button>
        <p-button (click)="onClose('cancel')" label="Cancel" styleClass="p-button-secondary"></p-button>
        <p-button (click)="saveWriteCheck()" label="Save" *ngIf="checkDialogType != 'VIEW'" [disabled]="(isAllowPostingPeriod && !updatedPostingPeriodInfo?.postingDate) || !!statementMessage || writeCheckForm?.controls?.amount?.value <= 0"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Select Vendor Address" [(visible)]="displayVendorAddress" [modal]="true" [responsive]="true" [closable]="false" [style]="{ width: '80vw' }" [baseZIndex]="9999">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="selectedVendor?.vendorAddresses" [(selection)]="selectedVendorAddress" dataKey="id" (onRowSelect)="onRowSelectAddress($event)" selectionMode="single">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Type</th>
                            <th>Street 1</th>
                            <th>Street 2</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Country</th>
                            <th>Zipcode</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-address>
                        <tr [pSelectableRow]="address">
                            <td>{{ address.address?.addressType?.name }}</td>
                            <td>{{ address.address?.streetAddress1 }}</td>
                            <td>{{ address.address?.streetAddress2 }}</td>
                            <td>{{ address.address?.city?.name }}</td>
                            <td>{{ address.address?.city?.state?.name }}</td>
                            <td>{{ address.address?.country?.name }}</td>
                            <td>{{ address.address?.zipCode }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayVendorAddress = false" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Select Vendor Contact" [(visible)]="displayVendorContact" [modal]="true" [responsive]="true" [closable]="false" [style]="{ width: '80vw' }" [baseZIndex]="9999">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="vendorDetails?.vendorContacts" [(selection)]="selectedVendorContact" dataKey="id" (onRowSelect)="onRowSelectContactVendor()" selectionMode="single">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Primary Contact</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-contact>
                        <tr [pSelectableRow]="contact" *ngIf="contact.statusId == 1">
                            <td>{{ contact.contact?.isPrimaryContact ? "Yes" : "No" }}</td>
                            <td>{{ contact.contact?.firstName }} {{ contact.contact?.lastName }}</td>
                            <td>{{ contact.contact?.contactEmails.length > 0 ? contact.contact?.contactEmails[0].email?.emailAddress : "" }}</td>
                            <td>{{ contact.contact?.contactPhones.length > 0 ? contact.contact?.contactPhones[0].phone?.number : "" }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayVendorContact = false" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Select Account Address" [(visible)]="displayAccountAddress" [modal]="true" [responsive]="true" [closable]="false" [style]="{ width: '80vw' }" [baseZIndex]="9999">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="accountInfo?.accountAddresses" [(selection)]="selectedAccountAddress" dataKey="id" (onRowSelect)="onRowSelectBillingAddress($event)" selectionMode="single">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Type</th>
                            <th>Street 1</th>
                            <th>Street 2</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Country</th>
                            <th>Zipcode</th>
                            <th>Attn</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr [pSelectableRow]="product">
                            <td>{{ product.address?.name }}</td>
                            <td>{{ product.address?.streetAddress1 }}</td>
                            <td>{{ product.address?.streetAddress2 }}</td>
                            <td>{{ product.address?.city?.name }}</td>
                            <td>{{ product.address?.city?.state?.name }}</td>
                            <td> {{ product.address?.city?.state?.country?.name }} </td>
                            <td>{{ product.address?.zipCode }}</td>
                            <td> {{ product.address?.attnContact?.firstName }} {{ product.address?.attnContact?.lastName ? " " : "" }} {{ product.address?.attnContact?.lastName }} </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayAccountAddress = false" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Select Contact" [(visible)]="displayContactSelectionModal" [modal]="true" [responsive]="true" [closable]="false" [style]="{ width: '80vw' }" [baseZIndex]="9999">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="accountInfo?.accountContacts" [(selection)]="selectedAccountContact" dataKey="id" (onRowSelect)="onRowSelectContactAccount($event)" selectionMode="single">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Primary Contact</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-contactInfo>
                        <tr [pSelectableRow]="contactInfo">
                            <td>{{ contactInfo?.isPrimaryContact ? "Yes" : "No" }}</td>
                            <td>{{ contactInfo?.contactName }}</td>
                            <td>
                                {{ contactInfo?.contact && contactInfo?.contact?.contactEmails && contactInfo?.contact?.contactEmails?.length > 0 && contactInfo?.contact?.contactEmails[0].email && contactInfo?.contact?.contactEmails[0].email?.emailAddress ? contactInfo?.contact?.contactEmails[0].email?.emailAddress : "" }}
                            </td>
                            <td>
                                {{ contactInfo?.contact?.contactPhones && contactInfo?.contact?.contactPhones?.length > 0 && contactInfo?.contact?.contactPhones[0].phone && contactInfo?.contact?.contactPhones[0].phone?.number ? contactInfo?.contact?.contactPhones[0].phone?.number : "" }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayContactSelectionModal = false" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<!-- expense -->
<p-dialog header="{{ expenseHeader }}" [(visible)]="displayAddExpense" [modal]="true" [responsive]="true" [closable]="false" [style]="{ width: '60vw' }" (onHide)="accountForm.reset()">
    <form [formGroup]="accountForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Finance Account <span style="color: red">*</span></label>
                    <liono-treeSelect class="border-bottom-input" [options]="financialAccounts" appendTo="body" placeholder="Select Financial Account" formControlName="financialAccountId" display="comma" [metaKeySelection]="false" selectionMode="single"></liono-treeSelect>
                </div>
                <div class="p-col-12 p-md-6">
                    <label>Amount <span style="color: red">*</span></label>
                    <p-inputNumber mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" formControlName="amount"></p-inputNumber>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Memo</label>
                    <textarea rows="5" cols="30" pInputTextarea formControlName="memo"></textarea>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton (click)="displayAddExpense = false" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton class="p-button-success" label="Save" [disabled]="!accountForm.valid" (click)="saveExpense(accountForm.value)"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Select Pay to" [(visible)]="displayAddPayto" [modal]="true" [responsive]="true" [style]="{ width: '60vw' }">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-d-flex">
                <div class="p-field-radiobutton">
                    <p-radioButton name="vendor" value="vendor" [(ngModel)]="payTo" [ngModelOptions]="{ standalone: true }" inputId="vendor"></p-radioButton>
                    <label for="vendor">Vendor</label>
                </div>
                <div class="p-field-radiobutton p-mx-3">
                    <p-radioButton name="customer" value="customer" [(ngModel)]="payTo" [ngModelOptions]="{ standalone: true }" inputId="customer"></p-radioButton>
                    <label for="customer">Customer</label>
                </div>
                <div class="p-field-radiobutton p-mx-3">
                    <p-radioButton name="employee" value="employee" [(ngModel)]="payTo" [ngModelOptions]="{ standalone: true }" inputId="employee"></p-radioButton>
                    <label for="employee">Employee</label>
                </div>
                <div class="p-field-radiobutton p-mx-3">
                    <p-radioButton name="other" value="other" [(ngModel)]="payTo" [ngModelOptions]="{ standalone: true }" inputId="other"></p-radioButton>
                    <label for="other">Other</label>
                </div>
            </div>
        </div>
        <div class="p-grid" *ngIf="payTo == 'vendor'">
            <div class="p-col-12 p-md-6">
                <label>Vendor</label>
                <p-dropdown [options]="allVendorsDD" [filter]="true" optionLabel="name" placeholder="Select Vendor" appendTo="body" [(ngModel)]="selectedVendorDD" [ngModelOptions]="{ standalone: true }" (onChange)="getSelectedVendorDetails(selectedVendorDD.id, 'show_list')"></p-dropdown>
            </div>
        </div>
        <div class="p-grid" *ngIf="payTo == 'employee'">
            <div class="p-col-12 p-md-6">
                <label>Employee</label>
                <p-dropdown [options]="allUser" [filter]="true" optionLabel="name" placeholder="Select Employee" appendTo="body" [(ngModel)]="selectedEmployee" [ngModelOptions]="{ standalone: true }"></p-dropdown>
            </div>
        </div>
        <div class="p-grid" *ngIf="payTo == 'customer'">
            <div class="p-col-12 p-md-6">
                <label>Channel</label>
                <p-dropdown [options]="accountChannels" optionLabel="name" appendTo="body" [filter]="true" [(ngModel)]="selectedChannel" [ngModelOptions]="{ standalone: true }" (onChange)="onChangeAccountChannel()"></p-dropdown>
            </div>
            <div class="p-col-12 p-md-6">
                <label>Account</label>
                <p-autoComplete [suggestions]="allAccountsDD" (completeMethod)="filterAccount($event)" field="nameWithSequenceNumber" [minLength]="1" placeholder="Search Account..." appendTo="body" (onSelect)="selectAccount($event.value)" [(ngModel)]="selectedAccount" [ngModelOptions]="{ standalone: true }">
                    <ng-template let-account pTemplate="account">
                        <div [ngStyle]="{'padding-left.px': account.level * 10}"> 
                           {{account?.level > 0 ? '-': ''}} {{ account.nameWithSequenceNumber }}           
                        </div>
                    </ng-template>
                </p-autoComplete>
            </div>
        </div>
        <div class="p-grid" *ngIf="payTo == 'vendor'">
            <div class="p-col-12">
                <label
                    >Address
                    <span *ngIf="activeVendorAddresses?.length > 1" (click)="onChangeVendor(vendorDetails, 'show_list')" class="p-ml-4 btnBars">
                        <i class="pi pi-pencil" *ngIf="checkDialogType != 'VIEW'"></i>
                    </span>
                </label>
                <p class="p-mb-0">
                    {{ selectedVendorDD?.name }}
                </p>
                <p class="p-mb-0"> {{ ordersVendorAddr }}<span *ngIf="ordersVendorAddr !== ''">,</span> </p>
                <p class="p-mb-0"> {{ ordersVendorCity }}<span *ngIf="ordersVendorCity !== ''">, </span> {{ ordersVendorState }} <span *ngIf="ordersVendorState !== ''">, </span> {{ ordersVendorCountry }} <span *ngIf="ordersVendorCountry !== ''">, </span> {{ ordersVendorZipcode }} </p>
                <p class="p-mb-0"
                    >{{ ordersVendorContact }}
                    <span *ngIf="vendorDetails?.vendorContacts?.length > 1" (click)="changeVendorContact()" class="p-ml-4 pointer">
                        <i class="pi pi-pencil" *ngIf="checkDialogType != 'VIEW'"></i>
                    </span>
                </p>
                <p class="p-mb-0">{{ ordersVendorPhone }}</p>
            </div>
        </div>
        <div class="p-grid" *ngIf="payTo == 'employee'">
            <div class="p-col-12">
                <label >Address </label>
                <p class="p-mb-0">
                    {{ selectedEmployee?.name }}
                </p>
                <p class="p-mb-0"> {{ selectedEmployee?.location?.address?.city?.name }}<span *ngIf="selectedEmployee && selectedEmployee?.location?.address?.city?.name !== ''">, </span>
                    {{ selectedEmployee?.location?.address?.state?.name }} <span *ngIf="selectedEmployee &&selectedEmployee?.location?.address?.state?.name !== ''">,
                    </span> {{ selectedEmployee?.location?.address?.country?.name }} <span *ngIf="selectedEmployee && selectedEmployee?.location?.address?.country?.name !== ''">, 
                    </span> {{ selectedEmployee?.location?.address?.zipCode }} </p>
            </div>
        </div>
        <div class="p-grid" *ngIf="payTo == 'customer'">
            <div class="p-col-12">
                <label
                    >Address
                    <span *ngIf="accountInfo && accountInfo.accountAddresses && accountInfo.accountAddresses.length > 0" class="p-ml-4 btnBars" (click)="editAccountAddress()">
                        <i class="pi pi-pencil" *ngIf="checkDialogType != 'VIEW'"></i>
                    </span>
                </label>
                <p class="p-mb-0"> {{ accountInfo?.businessName }} </p>
                <ng-container *ngIf="accountInfo">
                    <!-- Street -->
                    <p class="p-mb-0"> {{ accountAddressInfo?.address?.streetAddress1 }} <span *ngIf="accountAddressInfo?.address && accountAddressInfo?.address?.streetAddress1 && accountAddressInfo?.address?.streetAddress1 != '' && accountAddressInfo?.address?.streetAddress2 && accountAddressInfo?.address?.streetAddress2 != ''">,</span> {{ accountAddressInfo?.address?.streetAddress2 }} </p>
                    <!--Address-->
                    <p class="p-mb-0">
                        {{ accountAddressInfo?.address?.city?.name }} <span *ngIf="accountAddressInfo?.address && accountAddressInfo?.address?.city && accountAddressInfo?.address?.city?.name && accountAddressInfo?.address?.city?.name != '' && accountAddressInfo?.address?.city?.state && accountAddressInfo?.address?.city?.state?.name != ''">,</span> {{ accountAddressInfo?.address?.city?.state?.name }} <span *ngIf="accountAddressInfo?.address && accountAddressInfo?.address?.city && accountAddressInfo?.address?.city?.state && accountAddressInfo?.address?.city?.state?.name && accountAddressInfo?.address?.city?.state?.name != '' && accountAddressInfo?.address?.city?.state?.country && accountAddressInfo?.address?.city?.state?.country?.name != ''">,</span> {{ accountAddressInfo?.address?.city?.state?.country?.name }}
                        <span *ngIf="accountAddressInfo?.address && accountAddressInfo?.address?.city && accountAddressInfo?.address?.city?.state && accountAddressInfo?.address?.city?.state?.country && accountAddressInfo?.address?.city?.state?.country?.name && accountAddressInfo?.address?.city?.state?.country?.name != '' && accountAddressInfo?.address?.zipCode && accountAddressInfo?.address?.zipCode != ''">,</span> {{ accountAddressInfo?.address?.zipCode }}
                    </p>
                    <!--billing contact-->
                    <p class="p-mb-0 p-d-flex">
                        {{ billingAddressContact?.firstName }} {{ billingAddressContact?.lastName ? " " : "" }} {{ billingAddressContact?.lastName }}
                        <span class="p-ml-4 btnBars" (click)="openContactSelectionModal('BILLING')" *ngIf="this.accountInfo?.accountContacts.length > 1">
                            <i class="pi pi-pencil" *ngIf="checkDialogType != 'VIEW'"></i>
                        </span>
                    </p>
                    <p class="p-mb-0"> {{ billingAddressContact && billingAddressContact?.contactPhones && billingAddressContact?.contactPhones[0]?.phone && billingAddressContact?.contactPhones[0]?.phone?.number ? billingAddressContact?.contactPhones[0]?.phone?.number : "" }} </p>
                </ng-container>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="cancelPayTo()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton class="p-button-success" label="Save" (click)="savePayto()"></button>
    </p-footer>
</p-dialog>

<!--Product add -->
<app-product-selection-modal [displayProductSelectionModal]="displayProductSelectionModal" [moduleName]="moduleName" [headerText]="headerText" 
    [selectedProductsList]="selectedProductsList" [isVisibleLocation]="isVisibleLocation" (onCancelClicked)="onProductCancelClicked($event)" 
    (onProductAddComplete)="onProductAddComplete($event)" (onLocationSelect)="onLocationSelect($event)" 
    [selectedLocationId]="selectedLocationId" [selectDefaultLocation]="selectDefaultLocation">
</app-product-selection-modal>

<p-dialog class="customHeader" [(visible)]="displayCreditMemoViewDialog" [modal]="true" [responsive]="true" [closable]="true" [style]="{ width: '80vw' }" (onHide)="onDialogClose()">
    <div class="header" style="display: flex; justify-content: space-between;">
        <h5> Credit Memo
            <a class="btnBars p-mr-0 p-ml-2" (click)="navigateToCreditMemo(creditMemoDetails)">
                <i class="fa fa-external-link"></i>
            </a>
        </h5>
    </div>
    <div *ngIf="creditMemoDetails">
        <app-credit-memo-overview [creditMemoDetails]="creditMemoDetails"></app-credit-memo-overview>
    </div>
    <p-footer>
        <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<!-- Receive payment view -->
<div *ngIf="displayReceivedPayment && receivedPayment?.receivedPaymentId">
    <app-receive-payments 
        [receivedPaymentId]="receivedPayment?.receivedPaymentId" 
        [displayInvoiceReceive]="displayReceivedPayment"
        [type]="receivedPayment?.receivePaymentDialogType" 
        (invoiceReceiveEventEmitter)="onReceivePaymentsDialogClose($event)">
    </app-receive-payments> 
</div>

<!-- Vendor Credit Add/Edit -->
@if(displayVendorCreditAddEditDialog){
    <app-vendor-credit-add-edit 
    [displayVendorCreditAddEditDialog]="displayVendorCreditAddEditDialog"
    [vendorCreditDialogHeader]="vendorCreditDialogHeader" [selectedVendorCreditId]="selectedVendorCreditId"
    [dialogType]="vendorCreditDialogType" (onCloseVendorCreditDialog)="onCloseVendorCreditDialog($event)">
</app-vendor-credit-add-edit>
}

<!-- closing statement -->
<ng-container *ngIf="display">
    <app-closing-statement-validation
        [isClosingDate]="isAllowPostingPeriod ? (updatedPostingPeriodInfo?.postingDate ?? currentPostingPeriodInfo?.postingDate ?? null) : writeCheckForm?.controls?.checkDate?.value"
        [moduleName]="'Check'" (isClosingStatementDate)="isClosingStatementDate($event)">
    </app-closing-statement-validation>
 </ng-container>